import { FC, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

// types
import { PdpSharedSimilarAuctionItemsCarouselLazy_user$key } from './__generated__/PdpSharedSimilarAuctionItemsCarouselLazy_user.graphql';
import { PdpSharedSimilarAuctionItemsCarouselLazy_viewer$key } from './__generated__/PdpSharedSimilarAuctionItemsCarouselLazy_viewer.graphql';

export const PdpSharedSimilarAuctionItemsCarouselLazyComponent = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedSimilarAuctionItemsCarousel" */ './PdpSharedSimilarAuctionItemsCarousel'
        )
);

const viewerFragment = graphql`
    fragment PdpSharedSimilarAuctionItemsCarouselLazy_viewer on Viewer {
        ...PdpSharedSimilarAuctionItemsCarousel_viewer
    }
`;

const userFragment = graphql`
    fragment PdpSharedSimilarAuctionItemsCarouselLazy_user on User {
        ...PdpSharedSimilarAuctionItemsCarousel_user
    }
`;

export const PdpSharedSimilarAuctionItemsCarouselLazy: FC<{
    user?: PdpSharedSimilarAuctionItemsCarouselLazy_user$key | null;
    viewer: PdpSharedSimilarAuctionItemsCarouselLazy_viewer$key;
    currency: string;
}> = ({ currency, user: userRef, viewer: viewerRef }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const user = useFragment(userFragment, userRef);

    return (
        <ClientSuspense fallback={null}>
            <PdpSharedSimilarAuctionItemsCarouselLazyComponent
                user={user}
                viewer={viewer}
                currency={currency}
            />
        </ClientSuspense>
    );
};
